export default __webpack_public_path__ + "static/media/tts_en_head_a1(-10).547c5fda.mp3";